<template>
  <div id="Employee_policies">
    <div class="policies_view">
      <div class="default_top">
        <div>
          <span>Employee policies</span>
        </div>
        <div></div>
      </div>
      <div class="policy">
        <div class="title">
          <span>
            If the employee health score is below normal for
            <input type="number" min="0" /> days
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee has fever with body temperature greather than 37.5
            , deny access , ask the employee to work from home for
            <input
              type="number"
              min="0"
            /> days
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee has cold and cough symptons in the daily health
            declaration, deny access and ask the employee to work from home for
            <input
              type="number"
              min="0"
            /> days
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee has a travel history to a high risk zone , deny
            access and ask the employee to work from home for
            <input
              type="number"
              min="0"
            /> days
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee is under self quarantine
            <select name id>
              <option value="1">Action one</option>
              <option value="1">Action two</option>
              <option value="1">Action three</option>
              <option value="1">Action four</option>
              <option value="1">Action five</option>
            </select>
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee has a family member under govt or self quarantine
            <select name id>
              <option value="1">Action one</option>
              <option value="1">Action two</option>
              <option value="1">Action three</option>
              <option value="1">Action four</option>
              <option value="1">Action five</option>
            </select>
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee has a family member who has symptoms
            <select name id>
              <option value="1">Action one</option>
              <option value="1">Action two</option>
              <option value="1">Action three</option>
              <option value="1">Action four</option>
              <option value="1">Action five</option>
            </select>
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee was in close contact at work
            <select name id>
              <option value="1">Action one</option>
              <option value="1">Action two</option>
              <option value="1">Action three</option>
              <option value="1">Action four</option>
              <option value="1">Action five</option>
            </select>
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee was in a outbreak location , no action required
            <select name id>
              <option value="1">Action one</option>
              <option value="1">Action two</option>
              <option value="1">Action three</option>
              <option value="1">Action four</option>
              <option value="1">Action five</option>
            </select>
          </span>
        </div>
      </div>

      <div class="policy">
        <div class="title">
          <span>
            If the employee was in proximity contact with a known patient
            <select name id>
              <option value="1">Action one</option>
              <option value="1">Action two</option>
              <option value="1">Action three</option>
              <option value="1">Action four</option>
              <option value="1">Action five</option>
            </select>
          </span>
        </div>
      </div>
      <!-- <div class="footer text-center">
        <button class="main_btn" @click="add_employee()">
          Save<span class="mdi mdi-content-save-all-outline"></span>
        </button>
      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "Employee_policies",
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script>
